import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import bg1 from "../assets/BackgroundImages/BG image 1.png"; // example bg image
import bg2 from "../assets/BackgroundImages/BG image 2.png";

const Pricing = () => {
  return (
    <main className="pt-30">
      {/* Hero Section */}
      <section className="min-h-[calc(100vh-80px)] flex flex-col justify-center items-center text-center relative text-white">
        {/* Background Image Layers */}
        <div className="-z-10 absolute right-0 h-full opacity-50 translate-y-[-200px]">
          <img
            src={bg1}
            alt="bg"
            className="h-full w-auto object-contain"
          />
        </div>
        <div className="-z-10 absolute left-0 h-full opacity-50 md:translate-y-0">
          <img
            src={bg2}
            alt="bg"
            className="h-full w-auto object-contain"
          />
        </div>
        <div className="relative z-10 px-10">
          <h1 className="text-4xl sm:text-5xl font-bold">Our Pricing Plans</h1>
          <p className="text-lg mt-4 max-w-lg mx-auto">
            Choose a plan that fits your hiring needs, from AI-powered job posting to full automation and enterprise-level integrations.
          </p>
          {/* Plans Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            {/* Starter Plan */}
            <div className="bg-[#00cfc8] text-white rounded-xl shadow-lg p-8 flex flex-col transition-transform transform hover:scale-105">
              <h3 className="text-xl font-bold mb-1">
                Starter Plan <span className="text-sm font-normal">(For SMEs &amp; Startups)</span>
              </h3>
              <p className="text-sm mb-4">
                Perfect for small businesses and startups that need essential AI-powered recruitment tools to streamline hiring.
              </p>
              <ul className="space-y-2 text-left text-sm mb-4">
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-white mr-2 mt-1 flex-shrink-0" />
                  <span>
                    AI-powered Job Posting - AI optimizes job ads to improve visibility and engagement, ensuring they reach the right candidates across relevant job boards.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-white mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Basic Applicant Tracking System (ATS) - Manage candidates efficiently with a simple job application pipeline, from application to hiring.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-white mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Automated Candidate Ranking - AI scans and ranks resumes based on job requirements, helping recruiters quickly identify top candidates.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-white mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Limited AI Outreach - AI assists in reaching out to candidates but with restrictions compared to higher-tier plans.
                  </span>
                </li>
              </ul>
            </div>
            {/* Professional Plan */}
            <div className="bg-[#6960EC] text-white rounded-xl shadow-lg p-8 flex flex-col transition-transform transform hover:scale-105">
              <h3 className="text-xl font-bold mb-1">
                Professional Plan <span className="text-sm font-normal">(For Growing Teams &amp; Recruiters)</span>
              </h3>
              <p className="text-sm mb-4">
                Ideal for recruiters and businesses looking for enhanced automation and AI-driven hiring insights.
              </p>
              <ul className="space-y-2 text-left text-sm mb-4">
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#30D5C8] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Advanced AI Matching - Uses sophisticated AI algorithms to match job descriptions with the most relevant candidates based on experience, skills, and qualifications.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#30D5C8] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Automated Outreach &amp; Scheduling - AI automates candidate outreach with personalized messages and schedules interviews based on availability, reducing manual effort.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#30D5C8] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    CRM Features - Integrated Candidate Relationship Management (CRM) system to track candidate interactions, follow-ups, and engagement history.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#30D5C8] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Salary Insights - AI-driven salary benchmarking and market insights to help recruiters make competitive offers.
                  </span>
                </li>
              </ul>
            </div>
            {/* Enterprise Plan */}
            <div className="bg-[#38ACEC] text-white rounded-xl shadow-lg p-8 flex flex-col transition-transform transform hover:scale-105">
              <h3 className="text-xl font-bold mb-1">
                Enterprise Plan <span className="text-sm font-normal">(For Large-Scale Hiring &amp; Agencies)</span>
              </h3>
              <p className="text-sm mb-4">
                Designed for recruitment agencies and large organizations with complex, high-volume hiring needs.
              </p>
              <ul className="space-y-2 text-left text-sm mb-4">
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#99EDC3] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Full AI Automation - Automate the entire hiring process from sourcing candidates and ranking resumes to outreach and interview scheduling.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#99EDC3] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    API Integrations - Seamlessly connect with existing HR systems, payroll, onboarding software, and external job boards.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#99EDC3] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    DEI Compliance Tools - Ensure unbiased job descriptions and monitor diverse hiring practices.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#99EDC3] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Priority AI Job Visibility - Gain enhanced exposure for job postings to attract top candidates faster.
                  </span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle size={24} className="text-[#99EDC3] mr-2 mt-1 flex-shrink-0" />
                  <span>
                    Custom Pricing for Bulk Users - Tailored solutions for organizations with high-volume hiring.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Pricing Options Section (replacing FAQ) */}
      <section className="py-20 bg-[#11243b] text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h2 className="text-3xl font-bold text-center mb-12">Additional Pricing Options</h2>
          
          {/* AI-Powered Job Posting */}
          <div className="mb-10">
            <h3 className="text-2xl font-bold mb-2">
              AI-Powered Job Posting (Pay-Per-Job Model)
            </h3>
            <p className="text-sm mb-4">
              Enhance job visibility and reach top candidates with AI-driven job posting options.
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Basic Job Posting - AI optimization and standard job board distribution.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Enhanced Visibility - Featured placement and prioritized candidate matching.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Premium AI-Optimized - Maximum exposure and automated outreach to best-fit candidates.
                </span>
              </li>
            </ul>
          </div>
          
          {/* AI Feature Add-Ons */}
          <div className="mb-10">
            <h3 className="text-2xl font-bold mb-2">AI Feature Add-Ons</h3>
            <p className="text-sm mb-4">
              Upgrade your hiring workflow with powerful AI-driven features.
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  AI Interview Scheduling - Automates interview coordination with calendar sync.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Salary Benchmarking &amp; Insights - AI-driven salary analysis to stay competitive.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  DEI Compliance &amp; Bias Detection - Ensures fair and inclusive hiring practices.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  AI Candidate Outreach Automation - Personalized AI-driven candidate messaging.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Talent Pipeline Forecasting - Predicts hiring needs and future talent availability.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  AI Resume Screening - Instant analysis and ranking of resumes.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  Automated Reference Checks - AI-powered verification of candidate references.
                </span>
              </li>
            </ul>
          </div>
          
          {/* Enterprise API Licensing */}
          <div className="mb-10">
            <h3 className="text-2xl font-bold mb-2">Enterprise API Licensing</h3>
            <p className="text-sm mb-4">
              Seamlessly integrate AIAURA's AI capabilities into your existing hiring systems.
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  API Starter - Basic AI candidate matching and ATS integration.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  API Growth - Advanced automation and job board syndication.
                </span>
              </li>
              <li className="flex items-start">
                <FaCheckCircle size={24} className="text-[#19BFB7] mr-2 mt-1 flex-shrink-0" />
                <span>
                  API Enterprise - Full-scale automation with custom integrations.
                </span>
              </li>
            </ul>
          </div>
          
       
        </div>
      </section>

      {/* Call-to-Action Section */}
      
      <section className="py-20  text-white">
        {/* Background Image Layers */}
        <div className="-z-10 absolute right-0 h-full opacity-50 translate-y-[-200px]">
          <img
            src={bg1}
            alt="bg"
            className="h-full w-auto object-contain"
          />
        </div>
        <div className="-z-10 absolute left-0 h-full opacity-50 md:translate-y-0">
          <img
            src={bg2}
            alt="bg"
            className="h-full w-auto object-contain"
          />
        </div>
        <div className="max-w-6xl mx-auto px-5 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Upgrade?</h2>
          <p className="mb-6">Get in touch for pricing details tailored to your business needs.</p>
          <Link to="/contact">
            <button className="bg-[#19BFB7] border-2 border-[#19BFB7] rounded-full py-3 px-8 text-white hover:bg-white hover:text-[#0f1d35] transition duration-300 transform hover:scale-105">
              Contact Us
            </button>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Pricing;
